import Icon from "components/Activities/Icon";
import _ from "lodash";
import React, { memo } from "react";
import { Link } from "react-router-dom";
import { Create, Delete, DownloadDocument, Replace, Update, ViewDocument } from "../Items";
import ActivityItemDom from "./ActivityItemDom";

interface Props {
	activity: tcpinpoint.ActivityItem;
}

const ActivityFormItem = ({ activity }: Props) => {
	const props = { key: activity.attributes.item.id, activity };
	const link = `/forms/${_.get(activity.attributes.item.object, "id")}`;
	let output;
	let icon;

	switch (activity.attributes.item.type) {
		case "Read":
			// "Read" is emitted by the Form Show download button (see
			// v2/components/Forms/Show.tsx#onDownload) and mirrors the
			// Document download activity. Re-use the DownloadDocument
			// renderer — it just shows "<actor> downloaded <object.name>".
			icon = Icon("view");
			output = <DownloadDocument {...props} />;
			break;
		case "View":
			icon = Icon("view");
			output = <ViewDocument {...props} />;
			break;
		case "Create":
			icon = Icon("create-document");
			output = <Create {...props} />;
			break;
		case "Update":
			icon = Icon("create-document");
			output = <Update {...props} />;
			break;
		// Emitted by V2::FormsController#replace. Without this case the row
		// renders with no icon and no sentence at all.
		case "Replace":
			icon = Icon("replace-document");
			output = <Replace {...props} />;
			break;
		case "Delete":
			icon = Icon("delete-document");
			output = <Delete {...props} />;
			break;
	}

	return (
		<Link to={link} className="activity-item-link">
			{" "}
			<ActivityItemDom activity={activity} icon={icon} link={link} output={output} />
		</Link>
	);
};

export default memo(ActivityFormItem);
